import { PackageOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";

export default function BillingPackages() {
  const [, navigate] = useLocation();
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Packages</h1>
        <p className="text-sm text-muted-foreground">
          Bundles of plans + add-ons sold as a single SKU (e.g. &quot;Founder Bundle&quot; = 1 cabin + 10 conference hours + parking).
        </p>
      </div>

      <div className="flex flex-col items-center justify-center gap-3 rounded-md border border-dashed bg-muted/30 p-12 text-center">
        <PackageOpen className="h-10 w-10 text-muted-foreground/60" />
        <div className="space-y-1">
          <p className="text-sm font-medium">Packages module is on the roadmap</p>
          <p className="text-xs text-muted-foreground max-w-md">
            Phase 24&apos;s <span className="font-medium">plan_secondary_access</span> table already supports the
            single-plan version (a Workstation plan also grants Conference Room access). Multi-plan packages
            and add-on SKUs land in a future phase.
          </p>
        </div>
        <Button variant="outline" size="sm" onClick={() => navigate("/billing/plans")}>
          Browse Plans
        </Button>
      </div>
    </div>
  );
}
